import { loadStripe, type Stripe } from '@stripe/stripe-js';

let stripePromise: Promise<Stripe | null> | null = null;
let stripeKeyUsed: string | null = null;

export function getStripePromise(
  publishableKey?: string | null,
): Promise<Stripe | null> | null {
  const key =
    publishableKey?.trim() ||
    process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY?.trim() ||
    '';
  if (!key) return null;
  if (!stripePromise || stripeKeyUsed !== key) {
    stripeKeyUsed = key;
    stripePromise = loadStripe(key, {
      betas: ['elements_tax_id_1'],
    });
  }
  return stripePromise;
}
